import styles from "./no-data.module.scss";

import noDataImg from "@/assets/img/no-data/no-data.png";

const NoData = ({ message = "" }) => {
	return (
		<div className={styles.noData}>
			<img src={noDataImg} alt="Sin datos" className={styles.image} />
			<p className={styles.text}>{message}</p>
		</div>
	);
};

export default NoData;
